export { FooterLogo } from "./footer-logo";
